import React, { useState } from "react"
import Item from "./Item/item"

import classes from "./navigation.module.scss"

const navItems = [
  { id: "header", content: "Inicio" },
  { id: "schedule", content: "Horarios" },
  { id: "location", content: "Ubicación" },
  { id: "footer", content: "Contacto" },
]

const Navigation = () => {
  const [openNavigation, setOpenNavigation] = useState(false)

  const navigationClasses = [classes.Navigation]
  const navigationBgClasses = [classes.NavigationBackground]
  const mobileNavigationClasses = [classes.MobileNavigation]
  if (openNavigation) {
    navigationClasses.push(classes.NavigationOpened)
    navigationBgClasses.push(classes.ExpandNavigationBackground)
    mobileNavigationClasses.push(classes.MobileNavigationClose)
  }

  const toggleNavigation = () => {
    console.log("hello")
    setOpenNavigation(prevState => !prevState)
  }

  const listItems = navItems.map(item => (
    <Item key={item.id} id={item.id} content={item.content} clicked={toggleNavigation} />
  ))

  return (
    <div>
      <nav className={navigationClasses.join(" ")}>
        <ul>{listItems}</ul>
      </nav>
      <div className={navigationBgClasses.join(" ")}></div>
      <div
        className={mobileNavigationClasses.join(" ")}
        onClick={toggleNavigation}
      >
        <span></span>
      </div>
    </div>
  )
}

export default Navigation
